import React from 'react';

function IconSoldTag() {
  return (
    <svg
      width="18px"
      height="18px"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M507.137,249.793L263.443,4.927c-3.131-3.163-7.402-4.924-11.837-4.924H16.695C7.467,0.003,0,7.47,0,16.698v233.737    c0,4.434,1.761,8.674,4.892,11.804l244.867,244.867c6.521,6.521,17.087,6.521,23.609,0l233.737-233.737    C513.626,266.848,513.626,256.315,507.137,249.793z M116.869,166.958c-27.619,0-50.087-22.468-50.087-50.086    s22.468-50.087,50.087-50.087c27.619,0,50.086,22.468,50.086,50.087S144.487,166.958,116.869,166.958z"
            fill="#c6488c"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default IconSoldTag;
